import styled from "styled-components";

export const StyledExchangeColumns = styled.div`
  display: flex;
  margin-left: auto;
`

export const StyledExchangeColumnsIcon = styled.div`
    cursor: pointer;
`